import { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import HeaderTexts from "../../common/HeaderTexts";
import Label from "../../common/Label";
import { theme } from '../../../../theme';
import TextArea from '../../common/TextArea';

const radioOptions = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes, add job notes" }
];

const JobNote = ({ subSkill, jobNotes, setJobNotes, isHome }) => {
    const [isAddJobNotes, setIsAddJobNotes] = useState(jobNotes === "" ? false : true);

    const handleChange = (event) => {
        const value = event.target.value;
        setIsAddJobNotes(value === "yes");
    };

    return (
        <div className="form-group">
            <HeaderTexts
                title="Add notes about this job"
            />

            <div className="card-body">
                <Label
                    text={`Your selected service is: ${subSkill?.sub_skill_name || "Not specified"}`}
                />

                <p className="mt-3 mb-0 text-sm text-muted">
                    Is there anything else we should know about this job?
                </p>

                <FormControl
                    component="fieldset"
                    className="mt-3 w-100"
                >
                    <RadioGroup
                        value={isAddJobNotes ? "yes" : "no"}
                        onChange={handleChange}
                        name="job-note-radio-group"
                    >
                        {radioOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={
                                    <Radio
                                        size="small"
                                        color={theme.action_btn}
                                    />
                                }
                                label={option.label}
                                className="mb-0"
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                {isAddJobNotes && (
                    <div className="mt-3">
                        <TextArea
                            value={jobNotes}
                            onChange={setJobNotes}
                            placeholderText='Add any extra details about this job, access, symptoms, or related issues.'
                        />
                    </div>
                )}

                <p className={`mt-3 mb-0 text-sm text-muted ${!isHome && 'job-card-bg-color bg-opacity-10 p-3 rounded'}`}>
                    Important note: This booking is for the selected service only: Gas leak repairs. Job notes help the tradesperson prepare, but extra work is not guaranteed. If the work needs a different trade, or cannot be completed during the visit, a separate booking may be required.
                </p>
            </div>
        </div>
    );
};

export default JobNote;